
import React from "react"
import { Box } from "rebass"
import { Doughnut } from "react-chartjs-2"
import styles from "./ResponsiveDoughnut.module.css"

export default (props) => {
  const labels = props.data.labels || []
  const dataset = props.data.datasets?.[0] || {}
  const colors = dataset.backgroundColor || []

  return (
    <Box
      width={1}
      className={styles.chartWrap}
      sx={{ minWidth: 0, width: "100%" }}
    >
      <Doughnut
        height={200}
        width={220}
        options={{
          responsive: true,
          maintainAspectRatio: true,
          legend: { display: false },
          title: {
            display: true,
            text: props.text,
            fontSize: 24,
            fontColor: "#e8eef4",
            fontFamily: "Georgia, serif",
          },
          tooltips: {
            callbacks: {
              title: () => "",
              label: (tooltipItem, data) => {
                const dataLabel = data.labels[tooltipItem.index]
                const raw =
                  data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
                if (Array.isArray(dataLabel)) {
                  const copy = dataLabel.slice()
                  copy[0] = `${copy[0]}: ${raw}`
                  return copy
                }
                return `${dataLabel != null ? dataLabel : ""}: ${raw}`
              },
            },
          },
        }}
        data={props.data}
      />
      <ul className={styles.chartLegend} aria-label={`${props.text} legend`}>
        {labels.map((label, index) => (
          <li key={label}>
            <span
              className={styles.legendSwatch}
              style={{ backgroundColor: colors[index] }}
              aria-hidden="true"
            />
            <span>{label}</span>
          </li>
        ))}
      </ul>
    </Box>
  )
}
